export const MUDAD_SUBSCRIPTIONS_HISTORY_LOAD = 'MUDAD_SUBSCRIPTIONS_HISTORY_LOAD'
export const MUDAD_SUBSCRIPTIONS_HISTORY_LOAD_PENDING = 'MUDAD_SUBSCRIPTIONS_HISTORY_LOAD_PENDING'
export const MUDAD_SUBSCRIPTIONS_HISTORY_LOAD_FULFILLED =
  'MUDAD_SUBSCRIPTIONS_HISTORY_LOAD_FULFILLED'
export const MUDAD_SUBSCRIPTIONS_HISTORY_LOAD_REJECTED = 'MUDAD_SUBSCRIPTIONS_HISTORY_LOAD_REJECTED'
